<template>
  <div class="login">
    <el-form ref="loginForm"
             class="login-form"
             :model="loginForm"
             :rules="fieldRules">
      <h3 class="title">{{titleName?titleName:''}}信息管理系统</h3>
      <el-form-item prop="username">
        <el-input v-model="loginForm.username"
                  type="text"
                  clearable
                  placeholder="账号"
                  @blur="usernameFoc">
          <i slot="prefix"
             class="el-icon-user input-icon"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input v-model="loginForm.password"
                  type="password"
                  clearable
                  placeholder="密码"
                  @keyup.enter.native="loading?'':handleLogin()">
          <i slot="prefix"
             class="el-icon-lock input-icon"></i>
        </el-input>
      </el-form-item>
      <el-form-item v-if="itssusList">
        <el-select style="width:100%" v-model="loginForm.loginTissueId" filterable placeholder="请选择登录组织">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.tissueName"
            :value="item.id"
            @change="tissueChange">
          </el-option>
          <i slot="prefix"
             class="el-icon-monitor input-icon"></i>
        </el-select>
      </el-form-item>
      <!-- <el-form-item prop="code">
        <el-input id="code"
                  v-model="loginForm.code"
                  type="text"
                  clearable
                  placeholder="验证码"
                  style="float:left;width:170px"
                  @keyup.enter.native="loading?'':handleLogin()">
          <i slot="prefix"
             class="el-icon-picture-outline input-icon"></i>
        </el-input>
        <div id="image"
             style="float:left;margin-left:10px;width: 100px;height: 40px;">
        </div>
      </el-form-item> -->
      <!-- <div style="text-align:left">
        <el-checkbox v-model="loginForm.remenber">记住我</el-checkbox>
      </div> -->
      <el-form-item style="width:100%;">
        <el-button id="login"
                   size="medium"
                   :loading="loading"
                   type="primary"
                   style="width:100%;"
                   @click="handleLogin">
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
      </el-form-item>
      
    </el-form>
    <!--  底部  -->
    <div class="el-login-footer">
      <span class="toNew" @click="toNewUrl">闽ICP备2022014385号-1</span>
      <span>Copyright © 2021-{{yearDay}} 250123 boyo.fj All Rights Reserved.</span>
    </div>
  </div>
  
</template>

<script>
import md5 from 'js-md5'
/* eslint-disable */
import VerificationCode from '@/utils/VerificationCode'
import axios from 'axios'
// import { mapState } from 'vuex'
import store from "@/store";
export default {
  name: 'login',
  data () {
    return {
      yearDay:new Date().getFullYear(),
      // verifyCode: '',
      loading: false,
      itssusList:true,
      titleName:'',
      loginForm: {
        username: '',
        password: '',
        loginTissueId:'',
        loginTissueName:'',
        tPrefixion:'',//组织说明用于编号
        // code: '',
        remenber: false
      },
      options:[],
      fieldRules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        // code: [
        //   { required: true, message: '请输入验证码', trigger: 'blur' }
        // ]
      }
    }
  },
  mounted () {
    // this.verifyCode = new GVerify('image')
    // console.log(localStorage.username)
    try {
      if (localStorage.username) {
        this.loginForm.username = localStorage.username
        this.usernameFoc()
      }
    } catch (e) { }
    try {
      if (localStorage.password) {
        this.loginForm.password = localStorage.password
        this.loginForm.remenber = true
      }
    } catch (e) { }
    if (window.location.host && window.location.host == 'xcx.fzhsd.cn') {
      localStorage.titleName = '和顺德'
      this.titleName = '和顺德'
      document.title = '和顺德信息管理系统'
    }else{
      localStorage.titleName = '博亚水泥'
      this.titleName = '博亚水泥'
      document.title = '博亚水泥信息管理系统'
    }
  },
  methods: {
    usernameFoc(){
      if (!this.loginForm.username) {
        return
      }
      this.$api.user.getUserTissueList({username:this.loginForm.username,tStatus:1}).then(res => {
        localStorage.TissueList = []
        if (res.code === 0) {
          this.options = []
          this.loginForm.loginTissueId = ''
          this.loginForm.loginTissueName = ''
          this.loginForm.tPrefixion = ''
          if (res.data[0].id) {
            this.loginForm.loginTissueId = res.data[0].id
            this.loginForm.loginTissueName = res.data[0].tissueName
            this.loginForm.tPrefixion = res.data[0].tPrefixion
            this.options=res.data
            // store.state.tabs.TissueList = res.data
            this.$store.commit('TissueList', res.data)
            localStorage.TissueList = JSON.stringify(res.data)
          }
          // if (res.data =='管理员账户') {
          //   this.itssusList = false
          // }else{
          //   this.itssusList = true
          //   if (res.data[0].id) {
          //     this.loginForm.loginTissueId = res.data[0].id
          //     this.options.push({value:res.data[0].id,label:res.data[0].tissueName})
          //   }
          // }
        } else {
          this.$message({ message: res.msg, type: 'error' })
        }
      })
    },
    tissueChange(val){
      // for (let inde of this.options) {
      //   if (this.loginForm.loginTissueId == inde.id) {
      //   }
      // }
    },
    handleLogin () {
      // localStorage.loginTissueId = ''
      if (!this.loginForm.tPrefixion) {
        this.usernameFoc()
      }
      this.$refs.loginForm.validate((val) => {
        if (val) {
          // let res = this.verifyCode.validate(document.getElementById('code').value)
          // if (!res) {
          //   this.$message({ message: '验证码错误', type: 'error' })
          //   this.loginForm.code = ''
          //   return
          // }
          this.loading = true
          const data = JSON.parse(JSON.stringify(this.loginForm))
          data.password = md5.hex(data.password)
          for (let inda of this.options) {
            if (data.loginTissueId == inda.id) {
              data.loginTissueName = inda.tissueName
              data.tPrefixion = inda.tPrefixion
            }
          }
          delete data.code
          delete data.remenber
          this.$api.login.login(data).then(res => {
            if (res.code === 1) {
              this.loading = false
              // this.verifyCode.validate('')
              // this.loginForm.code = ''
              this.$message({ message: res.msg, type: 'error' })
            }
            else if (res.code === 0) {
              this.loading = false
              this.$store.commit('online', true)
              this.$localStorage.set('token', res.data.token, 12)
              this.$localStorage.set('longOut', res.data.user, 12)
              localStorage.roleId = res.data.user.userId
              localStorage.userId = res.data.user.userId
              localStorage.nickName = res.data.user.nickName
              localStorage.personal = JSON.stringify(res.data.user)
              localStorage.loginTissueId = this.loginForm.loginTissueId
              localStorage.loginTissueName = data.loginTissueName
              localStorage.tPrefixion = data.tPrefixion
              localStorage.menuNameActive = ''
              this.$message({ message: res.msg, type: 'success' })
              if (this.loginForm.remenber) {
                try {
                  localStorage.username = this.loginForm.username
                  localStorage.password = this.loginForm.password
                } catch (e) { }
              }
              else {
                try {
                  localStorage.username = ''
                  localStorage.password = ''
                } catch (e) { }
              }
              this.$router.push('/index')
            }
          }, err => {
            this.loading = false
          })
        }
      })
    },
    toNewUrl(){
      window.open('https://beian.miit.gov.cn')
    }
  }
}
</script>
<style lang="stylus" scoped>
@media screen and (max-height 450px)
  .title
    display none
  .el-login-footer
    display none
.login
  display flex
  justify-content center
  align-items center
  height 100%
  background-image url('../assets/images/login-background.jpg')
  background-size cover
.title
  margin 0px auto 30px auto
  text-align center
  color #707070
.login-form
  border-radius 6px
  background rgba(255, 255, 255, 0.8)
  width 280px
  padding 25px 25px 5px 25px
  .el-form-item
    margin-bottom 25px
  .input-icon
    height 39px
    width 14px
    margin-left 2px
    font-size 18px
.el-login-footer
  height 40px
  line-height 40px
  position fixed
  bottom 0
  width 100%
  text-align center
  color #fff
  font-family Arial
  font-size 12px
  letter-spacing 1px
.toNew
  display inline-block
  cursor pointer
  margin-right 10px
.toNew:hover
  color #000
</style>



// WEBPACK FOOTER //
// src/views/login.vue